var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// server/services/tasmota/lib/features/modules.js
var require_modules = __commonJS({
  "server/services/tasmota/lib/features/modules.js"(exports, module) {
    var LIGHT_MODULES = [9, 11, 26, 37];
    module.exports = {
      LIGHT_MODULES
    };
  }
});
const __cjsModule = require_modules();
export default __cjsModule;
export const LIGHT_MODULES = __cjsModule.LIGHT_MODULES;
